import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import { data } from '../../constants/Constants';
import c from '../../constants/Colors';
import { BuscarCarritoPedido } from '../../store/sagas/carritoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { AuthContext } from "../../store/provider/AuthProvider";
import { notificacion, getStatePage } from '../../utilitarios/util';
import ModalSinStock from "../reusable/modals/SinStock";
import Spinner from "../reusable/Loader";

const CardEnvio = ({ seleccionarLocal, local, localSel, localId }) => {

  localSel = localSel == null ? { localId: 0 } : localSel
  return (
    <div className="card_product_horizontal card_envio">
      <div className="cphCounterInput check" style={{ backgroundColor: c.verdeClaro }}>
        <div className="custom-control custom-radio">
          <input type="radio" id={`radio${local.localId}`} name="radio_ln" className="custom-control-input"
            checked={(local.localId == localSel.localId || local.localId == localId)}
            onChange={() => seleccionarLocal(local)}
          />
          <label className="custom-control-label" htmlFor={`radio${local.localId}`}></label>
        </div>
      </div>
      <div className="cphTextCenter">
        {(local.ultimoPedido != "") ?
          <h6 className="paragraph-2 bold" style={{ color: c.verdeClaro }}>{local.ultimoPedido}</h6>
          : null}
        {(local.alias != "") ?
          <div>
            <p className="alias" style={{ color: c.azulClaro }}><SvgAssets icon="icon-local" fill={c.azulClaro} />{local.alias}</p>
            <span className="address light" style={{ color: c.azulClaro }}>{local.direccion}</span>
          </div>
          : <span className="address bold" style={{ color: c.azulClaro }}>{local.direccion}</span>}
      </div>
    </div>
  )
}

export class CarritoEnvio extends Component {
  static displayName = CarritoEnvio.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      locales: [],
      alertas: [],
      local: null,
      datosTotal: {},
      productos: [],
      localId: 0,
      pedidoId: 0,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      addStock: false
    };
  }

  showCarrito = () => {
    this.setState({ addToCart: false, loading: false }, () => {
      // this.props.navigation.navigate('CarritoListado');
      this.props.history.push({
        pathname: '/carrito',
        state: { datosBuscador: { localId: 0 } }
      });
    });
  }

  checkParams() {
    const { state } = this.props.location;
    if (state != undefined) {
      let _datosTotal = state.datosTotal;
      this.setState({
        datosTotal: _datosTotal,
        localId: state.localId
      });
    }
  }
  IrOfertas = () => {
    this.props.history.push('/carrito-ofertas');
  }
  seleccionarLocal = (value) => {
    const auth = this.context;
    auth.setLocalEnvio(value.localId);
    this.setState({ local: value, localId: value.localId })
  }
  IrTransportistas = () => {
    this.props.history.push({
      pathname: 'transportistas',
      state: {
        datosTotal: this.state.datosTotal,
        datosLocal: this.state.local,
        // pedidoId: this.state.pedidoId,
        localId: this.state.localId
      }
    });
  }
  // IrMedioPago = () => {
  //   this.props.history.push({
  //     pathname: 'medio-pago',
  //     state: {
  //       datosTotal: this.state.datosTotal,
  //       datosLocal: this.state.local,
  //       // pedidoId: this.state.pedidoId,
  //       localId: this.state.localId
  //     }
  //   });
  // }
  load = () => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({
      loading: true,
      dealer: data.dealer,
      linea: data.linea,
      asociado: data.asociado,
      addStock: false
    }, () => {
      this.postBuscarCarritoPedido();
    })
  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      this.load();
      this.setState({
        local: null
      });
      this.checkParams();
    } else
      window.location.href = "/";
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { locales, datosTotal, alertas, local, loading, localId } = this.state;
    const auth = this.context;
    console.log("Medio Pago auth", auth.mostrarOfertas);
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1><SvgAssets icon="icon-envio" fill='#fff' />Envío</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li><Link to='/carrito'>Carrito de compras</Link></li>
              {(auth.mostrarOfertas) ?
                <li><Link to={{ pathname: '/carrito/ofertas', state: { datosTotal: this.state.datosTotal, datosProductos: this.state.productos, localId: this.state.localId } }}>Ofertas</Link></li>
                : null}
              <li>Envío</li>

            </ul>
          </Container>
        </div>
        <Container className="pt-5 pb-float">
          <h6 className="title white mobile">
            <Link to={{ pathname: '/carrito/ofertas', state: { datosTotal: this.state.datosTotal, datosProductos: this.state.productos, localId: this.state.localId } }} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>
            <SvgAssets icon="icon-envio" fill="#fff" />Envío
          </h6>
          <div className="card container_1080">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            {locales.map((data, index) => {
              return (
                <CardEnvio key={index} seleccionarLocal={this.seleccionarLocal} local={data} localSel={local} localId={localId} />
              )
            })}
            {/* <CardEnvio />
            <CardEnvio /> */}
            {/* <p className="total-price">TOTAL: {datosTotal.moneda} {datosTotal.total}</p>
            <button
              className={`btn-block${(!(local != null) ? " disabled" : "")}`}
              disabled={!(local != null)}
              onClick={() => this.IrMedioPago()}
            >
              siguiente
                </button> */}
          </div>
        </Container>
        <div className="float_section">
          <SvgAssets icon="curve-top" className="curve" fill={c.azul} />
          <p className="total-price">TOTAL: <span>{datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
          </p>
          <button
            className={`btn-block${(local == null || datosTotal.total <= 0 ? " disabled" : "")}`}
            disabled={(local == null || datosTotal.total <= 0)}
            // onClick={() => this.IrMedioPago()}
            onClick={() => this.IrTransportistas()}
          >
            siguiente
          </button>
        </div>
        <ModalSinStock dadComponent={this} />
      </div >
    );
  }

  postBuscarCarritoPedido = async () => {

    BuscarCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado, this.state.localId, this.state.pedidoId)
      .then(result => {
        if (result.mo.type == "success") {
          const auth = this.context;
          let LOCAL_SESION = auth.localEnvio;
          let local = null;

          local = result.dto.perfil.locales.find(item => item.localId === LOCAL_SESION);

          if (local == null)
            local = result.dto.perfil.locales[0];


          auth.setLocalEnvio(local.localId);

          let productosSinStock = result.dto.repuestos.filter(t => !t.validaStok).length;
          let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;
          if (productosSinStock > 0) {
            this.setState({
              addStock: true,
              loading: false
            });
          } else {
            this.setState({
              addStock: false,
              loading: false,
              productos: result.dto.repuestos,
              alertas: result.dto.alertas,
              locales: result.dto.perfil.locales,
              datosTotal: {
                total: _total,
                moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
              },
              local: local,
              localId: local?.localId
            });


            if (_total == 0)
              notificacion("Carrito", data.MensajeSinProducto);
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Carrito", error.message ?? null);
        });
      });
  }

  notificacion = async (alertTitulo = "", alertMensaje = "") => {
    this.setState({ alertTitulo, alertMensaje });
    this.toggleModalAlert();
  }
  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }
}


